<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates12">
<p class="centerImage"><img alt="images" id="plate12" src="images/plate12.jpg"/></p>
<p class="caption">Alec Ingle, with pipe, adjusts my mae west, while Ricky Wright, wearing gauntlets, looks on. <em class="italic">(Chris Goss)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates12.vue?6ab7daa2